export const ANNOTATION_VALUE = {
  YES: "YES",
  NO: "NO",
  UNKNOWN: "UNKNOWN",
} as const
export type AnnotationValue =
  (typeof ANNOTATION_VALUE)[keyof typeof ANNOTATION_VALUE]
